import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1105InputModel } from '../kymw1100/vo/kymw1105-input.model';
import { GetGoodsSpecificationInfoService } from './api-services/get-goods-specification-info.service';
import { KYMW1105OutputModel } from '../kymw1100/vo/kymw1105-output.model';
import { Component, OnInit, ViewChild, ViewEncapsulation, ElementRef, ChangeDetectorRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1105Model } from './kymw1105.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { TextAreaComponent } from 'src/app/commons/kymw02/text-input/text-area/text-area.component';

/**
 * eBASEデータ画面を管理するクラス
 *
 * @export KYMW1105Component
 * @class KYMW1105Component
 */
@Component({
  selector: 'app-kymw1105',
  templateUrl: 'kymw1105.component.html',
  styleUrls: ['kymw1105.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1105Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw1105Model: KYMW1105Model = new KYMW1105Model();

  // ウィンドウを閉じる際の処理
  closeFunction;

  // 受渡し情報
  public inputVo: KYMW1105InputModel = null;

  /**
   *Creates an instance of KYMW1105Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1105Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    public getGoodsSpecificationInfoService: GetGoodsSpecificationInfoService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(kymw00Model);
  }

  @ViewChild('rdb_Form_Piece', { static: true }) rdb_Form_Piece: RadioLabelComponent;
  @ViewChild('rdb_Form_Pack', { static: true }) rdb_Form_Pack: RadioLabelComponent;
  @ViewChild('rdb_Form_Bowl', { static: true }) rdb_Form_Bowl: RadioLabelComponent;
  @ViewChild('rdb_Form_Case', { static: true }) rdb_Form_Case: RadioLabelComponent;
  @ViewChild('btn_Form_Set', { static: true }) btn_Form_Set: ElementRef;
  @ViewChild('rdb_JanCode_Piece', { static: true }) rdb_JanCode_Piece: RadioLabelComponent;
  @ViewChild('rdb_JanCode_Pack', { static: true }) rdb_JanCode_Pack: RadioLabelComponent;
  @ViewChild('rdb_JanCode_Bowl', { static: true }) rdb_JanCode_Bowl: RadioLabelComponent;
  @ViewChild('rdb_JanCode_Case', { static: true }) rdb_JanCode_Case: RadioLabelComponent;
  @ViewChild('btn_JanCode_Set', { static: true }) btn_JanCode_Set: ElementRef;
  @ViewChild('btn_TextInfo_Set', { static: true }) btn_TextInfo_Set: ElementRef;
  @ViewChild('txta_FactoryAddress', {static: true}) txta_FactoryAddress: TextAreaComponent;

  /**
   * 初期処理
   *
   * @memberof KYMW1105Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1105';

    this.kymw1105Model.kymw1105Component = this;

    setTimeout(() => {
      this.plessEnabledSetting();
    });

    // eBASEデータ画面の初期表示情報を取得する。
    // 受け渡されたPコード、アイテムコードをもとに、
    // 関連商品仕様書情報を取得するための要求をサーバ側へ送信
    this.getGoodsSpecificationInfoService.execute(this.kymw1105Model, this.inputVo);

    this.changeDetectorRef.detectChanges();
        
    // 工場住所のテキストエリア活性制御
    // 閲覧ユーザーは非活性にする
    if (this.getFuncPermission('KYMW1100') === "1") {
      this.plessEnabled(this.txta_FactoryAddress, false);
    }
  }

  public plessEnabledSetting() {
    this.plessEnabled(this.rdb_Form_Piece, false);                              // 商品形態タブ ピースラジオボタン
    this.plessEnabled(this.rdb_Form_Pack, false);                               // 商品形態タブ パックラジオボタン
    this.plessEnabled(this.rdb_Form_Bowl, false);                               // 商品形態タブ ボールラジオボタン
    this.plessEnabled(this.rdb_Form_Case, false);                               // 商品形態タブ ケースラジオボタン
    this.plessEnabled(this.btn_Form_Set, false);                                // 商品形態タブ 設定ボタン

    this.plessEnabled(this.rdb_JanCode_Piece, false);                           // ＪＡＮコードタブ ピースラジオボタン
    this.plessEnabled(this.rdb_JanCode_Pack, false);                            // ＪＡＮコードタブ パックラジオボタン
    this.plessEnabled(this.rdb_JanCode_Bowl, false);                            // ＪＡＮコードタブ ボールラジオボタン
    this.plessEnabled(this.rdb_JanCode_Case, false);                            // ＪＡＮコードタブ ケースラジオボタン
    this.plessEnabled(this.btn_JanCode_Set, false);                             // ＪＡＮコードタブ 設定ボタン

    this.plessEnabled(this.btn_TextInfo_Set, false);                            // 工場住所タブ 設定ボタン
  }

  public setKYMW1105Parameter(outputVO: KYMW1105OutputModel) { }

  public setInterfaceParam(param: any): void {
    // 受渡情報の設定
    this.inputVo = <KYMW1105InputModel>(param);
  }

  /**
   * サイズ・重量設定チェック処理
   *
   * @param {string} length 縦
   * @param {string} width 横
   * @param {string} height 高さ
   * @param {string} weight 重量
   * @returns {boolean} チェック結果
   * @memberof KYMW1105Component
   */
  public checkFormSize(length: string, width: string, height: string, weight: string): boolean {
    let checkResult: boolean = <boolean>true;                                   // チェック結果

    // 各情報の存在チェック
    // 存在しない場合はチェック結果にfalseを設定する。
    if (PlessViewUtilsSub.isEmpty(length)) {                                    // 縦
      checkResult = false;
    }
    if (PlessViewUtilsSub.isEmpty(width)) {                                     // 横
      checkResult = false;
    }
    if (PlessViewUtilsSub.isEmpty(height)) {                                    // 高さ
      checkResult = false;
    }
    if (PlessViewUtilsSub.isEmpty(weight)) {                                    // 重量
      checkResult = false;
    }

    // チェック結果を返却
    return checkResult;
  }

  /**
   * 工場住所設定ボタン活性判定処理
   *
   * @memberof KYMW1105Component
   */
  public setFactoryAddressEnabled(): void {
    // 工場住所空文字判定
    if (!PlessViewUtilsSub.isEmpty(this.kymw1105Model.factoryAddress)) {        // 空文字以外の場合
      // 工場住所設定カウンタ判定
      if (this.kymw1105Model.factoryAddressCount === 0) {                       // 0の場合
        // 活性を設定
        this.plessEnabled(this.btn_TextInfo_Set, true);                         // 工場住所設定ボタン
      } else {                                                                  // 0以外の場合
        // 非活性を設定
        this.plessEnabled(this.btn_TextInfo_Set, false);                        // 工場住所設定ボタン
      }
    } else {                                                                    // 空文字の場合
      // 非活性を設定
      this.plessEnabled(this.btn_TextInfo_Set, false);                          // 工場住所設定ボタン
    }
  }

  /**
   * 設定ボタン処理(商品形態タブ）
   *
   * @returns {void}
   * @memberof KYMW1105Component
   */
  public eventFormSetButtom_CLICKHandler(): void {
    // 変数定義
    const outputVO: KYMW1105OutputModel = new KYMW1105OutputModel();            // 出力用VO

    // 出力用VOに設定
    // 処理区分に1:商品形態を設定
    outputVO.procDiv = '1';                                                     // 処理区分(1:商品形態)

    // 選択したラジオボタンにより値を設定
    if (this.kymw1105Model.grpForm === '1') {                                   // ピースを選択の場合

      // ピースの値を設定
      outputVO.sizeLength = this.kymw1105Model.pieceSizeLength;                 // サイズ(縦)
      outputVO.sizeWidth = this.kymw1105Model.pieceSizeWidth;                   // サイズ(横)
      outputVO.sizeHeight = this.kymw1105Model.pieceSizeHeight;                 // サイズ(高)
      outputVO.weight = this.kymw1105Model.pieceWeight;                         // 重量
    } else if (this.kymw1105Model.grpForm === '2') {                            // パックを選択の場合

      // パックの値を設定
      outputVO.sizeLength = this.kymw1105Model.packSizeLength;                  // サイズ(縦)
      outputVO.sizeWidth = this.kymw1105Model.packSizeWidth;                    // サイズ(横)
      outputVO.sizeHeight = this.kymw1105Model.packSizeHeight;                  // サイズ(高)
      outputVO.weight = this.kymw1105Model.packWeight;                          // 重量
    } else if (this.kymw1105Model.grpForm === '3') {                            // ボールを選択の場合

      // ボールの値を設定
      outputVO.sizeLength = this.kymw1105Model.bowlSizeLength;                  // サイズ(縦)
      outputVO.sizeWidth = this.kymw1105Model.bowlSizeWidth;                    // サイズ(横)
      outputVO.sizeHeight = this.kymw1105Model.bowlSizeHeight;                  // サイズ(高)
      outputVO.weight = this.kymw1105Model.bowlWeight;                          // 重量
    } else if (this.kymw1105Model.grpForm === '4') {                            // ケースを選択の場合

      // ケースの値を設定
      outputVO.sizeLength = this.kymw1105Model.caseSizeLength;                  // サイズ(縦)
      outputVO.sizeWidth = this.kymw1105Model.caseSizeWidth;                    // サイズ(横)
      outputVO.sizeHeight = this.kymw1105Model.caseSizeHeight;                  // サイズ(高)
      outputVO.weight = this.kymw1105Model.caseWeight;                          // 重量
    } else {                                                                    // 未選択の場合

      this.dialogService.openAlertGetMessage('E0103', ['商品形態']);
      return;
    }

    // 親画面に選択した情報を返却する
    this.setKYMW1105Parameter(outputVO);
  }

  /**
   * 設定ボタン処理(JANコードタブ）
   *
   * @returns {void}
   * @memberof KYMW1105Component
   */
  public eventJanCodeSetButtom_CLICKHandler(): void {
    // 変数定義
    const outputVO: KYMW1105OutputModel = new KYMW1105OutputModel();            // 出力用VO

    // 出力用VOに設定
    // 処理区分に2:JANコードを設定
    outputVO.procDiv = '2';                                                     // 処理区分(2:JANコード)

    // 選択したラジオボタンにより値を設定
    if (this.kymw1105Model.grpJanCode === '1') {                                // ピースを選択の場合

      // ピースの値を設定
      outputVO.janCode = this.kymw1105Model.pieceJanCode;                       // ＪＡＮコード
    } else if (this.kymw1105Model.grpJanCode === '2') {                         // パックを選択の場合
      // パックの値を設定
      outputVO.janCode = this.kymw1105Model.packJanCode;                        // ＪＡＮコード
    } else if (this.kymw1105Model.grpJanCode === '3') {                         // ボールを選択の場合
      // ボールの値を設定
      outputVO.janCode = this.kymw1105Model.bowlJanCode;                        // ＪＡＮコード
    } else if (this.kymw1105Model.grpJanCode === '4') {                         // ケースを選択の場合
      // ケースの値を設定
      outputVO.janCode = this.kymw1105Model.caseJanCode;                        // ＪＡＮコード
    } else {                                                                    // 未選択の場合
      this.dialogService.openAlertGetMessage('E0103', ['ＪＡＮコード']);
      return;
    }

    // 親画面に選択した情報を返却する
    this.setKYMW1105Parameter(outputVO);
  }

  /**
   * 設定ボタン処理(工場住所タブ）
   *
   * @memberof KYMW1105Component
   */
  public eventTextInfoSetButtom_CLICKHandler(): void {
    // 変数定義
    let factoryLocation: string = <string>'';                                   // 原産国加工地
    const outputVO: KYMW1105OutputModel = new KYMW1105OutputModel();            // 出力用VO

    // 工場住所設定カウンタをカウントアップ
    this.kymw1105Model.factoryAddressCount = this.kymw1105Model.factoryAddressCount + 1;

    // 工場住所設定ボタン活性判定処理
    this.setFactoryAddressEnabled();

    // 原産国加工地を編集（画面入力値の先頭に”製造”、末尾に"。"を付加）
    factoryLocation = '製造' + this.kymw1105Model.factoryAddress + '。';        // 原産国加工地

    // 出力用VOに設定
    // 処理区分に3:原産国加工地を設定
    outputVO.procDiv = '3';                                                     // 処理区分(3:原産国加工地)
    outputVO.textInfo_005 = factoryLocation;                                    // 原産国加工地

    // 親画面に選択した情報を返却する
    this.setKYMW1105Parameter(outputVO);
  }

}
